import { COLOR_PALETTE } from 'constants/ui';

// Dark: the light pale ORANGE/RED tints would render near-white on the dark canvas, so use the
// variant soft tints; light keeps the original pale surfaces.
const getFailureSurface = (palette, transient) => {
  if (palette.mode === 'dark') {
    return transient ? palette.warning.soft : palette.error.soft;
  }

  return transient ? COLOR_PALETTE.ORANGE[1] : COLOR_PALETTE.RED[1];
};

// A transient failure ("usually fixes itself on retry") gets the calmer amber
// tone; a hard failure keeps the red so severity reads at a glance.
export const containerStyles =
  transient =>
  ({ palette }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    padding: '16px',
    borderTop: `1px dashed ${palette.border.input}`,
    backgroundColor: getFailureSurface(palette, transient),
  });

export const sectionTitleStyles = {
  color: ({ palette }) => palette.text.strong,
  marginBottom: '4px',
};

export const sectionBodyStyles = {
  color: ({ palette }) => palette.text.dark,
};

export const recoveryRowStyles = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '8px',
};

export const copyRowStyles = {
  display: 'flex',
  gap: '8px',
  alignItems: 'baseline',
  color: ({ palette }) => palette.text.dark,
};

export const idValueStyles = {
  fontFamily: 'monospace',
  color: ({ palette }) => palette.text.strong,
  wordBreak: 'break-all',
};

export const hintStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  padding: '4px 10px',
  borderRadius: '999px',
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.warning.soft : COLOR_PALETTE.ORANGE[1],
  color: ({ palette }) =>
    palette.mode === 'dark' ? palette.warning.main : COLOR_PALETTE.ORANGE[8],
  alignSelf: 'flex-start',
};

export const eventsListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  paddingLeft: '4px',
};

export const eventItemStyles = {
  display: 'flex',
  gap: '8px',
  alignItems: 'baseline',
  color: ({ palette }) => palette.text.dark,
};

export const eventTimeStyles = {
  color: ({ palette }) => palette.text.secondary,
  minWidth: '64px',
  fontVariantNumeric: 'tabular-nums',
};

export const technicalLinkRowStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
};

export const technicalLinkStyles = {
  color: ({ palette }) => palette.text.secondary,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',

  '&:hover': {
    color: ({ palette }) => palette.text.strong,
  },
};

export const technicalDetailsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '10px 12px',
  borderRadius: '6px',
  backgroundColor: ({ palette }) => palette.background.secondary,
  fontFamily: 'monospace',
  fontSize: '12px',
  color: ({ palette }) => palette.text.strong,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};
